export const getFormattedDateNumber = number => {
    const MIN_DATE_NUMBER_LENGTH = 2

    return number.toString().length < MIN_DATE_NUMBER_LENGTH
        ? `0${number}`
        : number
}
